import { BorderGridContainer, GridBox, H1, Spinner } from '@ahmdigital/ui';
import { ReactNode } from 'react';

import { Article } from '../../types/__codegen__/sanity/graphql';
import { Container, TilesWrapper } from './styles';
import { CustomExplainedTerm } from '../explained-term/detail/utils/format-data-for-content-tile/types';
import { ITEMS_PER_PAGE } from './constants';
import constants from '../../ahm-constants';
import getPaginationData from './utils/get-pagination-data';
import Pagination from './components/pagination';
import RedirectAdapter from '../../utils/redirect-adapter';

type PagesHubProps = {
  children: ReactNode;
  itemsToDisplay: CustomExplainedTerm[] | Article[] | null;
  featuredItem?: ReactNode;
  filterBar?: ReactNode;
  currentPage: number;
  isLoading?: boolean;
  totalOfItems: number;
  title: string;
};

const { URLS } = constants;

const PagesHub = ({
  children,
  itemsToDisplay,
  featuredItem,
  filterBar,
  currentPage,
  isLoading,
  totalOfItems,
  title,
}: PagesHubProps) => {
  const amountOfPages = Math.ceil(totalOfItems / ITEMS_PER_PAGE);

  const { canGoBack, canGoForward, pagesToDisplay } = getPaginationData({
    amountOfPages,
    currentPageNumber: currentPage,
  });

  if (!itemsToDisplay) {
    return <RedirectAdapter to={URLS.SALES.ERROR_404} />;
  }

  return (
    <BorderGridContainer hideBorderTop>
      <GridBox padding="0">
        <Container>
          <H1 variant="marginBottomSpacer6">{title}</H1>
          {featuredItem}
          {filterBar}
          {isLoading ? (
            <Container>
              <Spinner testId="content-spinner" />
            </Container>
          ) : (
            <TilesWrapper>{children}</TilesWrapper>
          )}
          <Pagination
            canGoBack={canGoBack}
            canGoForward={canGoForward}
            currentPage={currentPage}
            pagesToDisplay={pagesToDisplay}
          />
        </Container>
      </GridBox>
    </BorderGridContainer>
  );
};

export default PagesHub;
